import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

// columns: [{ key, label, align?, render?: (row) => node }]
const DataTable = ({ columns, rows, getRowKey, emptyMessage = "Brak danych", size = "medium" }) => (
  <TableContainer>
    <Table size={size}>
      <TableHead>
        <TableRow>
          {columns.map((col) => (
            <TableCell key={col.key} align={col.align}>
              {col.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows && rows.length > 0 ? (
          rows.map((row, index) => (
            <TableRow key={getRowKey ? getRowKey(row, index) : index} hover>
              {columns.map((col) => (
                <TableCell key={col.key} align={col.align}>
                  {col.render ? col.render(row) : row[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={columns.length} align="center">
              <Typography variant="body2" color="text.secondary">
                {emptyMessage}
              </Typography>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default DataTable;
